import {Access} from '../helpers';
import {RoleSensitivityLevel} from "./roleSensitivityLevel";

export class SystemRolePrivilege {
  role: string;
  isInternal: boolean;
  access: Access;
  sensitivityLevel: RoleSensitivityLevel;
  authorizedFunctionsPerformed: string;
  authorizedPrivileges: string;
  functionsPerformed: string;
}
